import asyncActionSwal from 'utils/asyncActionSwal';
import { CustomRange } from '../types/CustomRange';

type WithUnsavedCheckProps = {
  editedRanges: CustomRange[];
  action: () => void;
  translationFunction: (key: string) => string; // eslint-disable-line
};

export const withUnsavedCheck = ({
  editedRanges,
  action,
  translationFunction,
}: WithUnsavedCheckProps) => {
  if (editedRanges.length > 0) {
    asyncActionSwal({
      swalTitle: translationFunction('UnsavedMovementsWillBeLost'),
      swalElementName: '',
      swalInfoText: '',
      swalConfirmButtonText: translationFunction('Continue'),
      callback: action,
    });
  } else {
    action();
  }
};
